import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_row = _resolveComponent("v-row")!
  const _component_Badge = _resolveComponent("Badge")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_PriceDisplay = _resolveComponent("PriceDisplay")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_row, { class: "ma-0 mx-4 mt-4 mb-2 token-text-h5" }, {
      default: _withCtx(() => _cache[0] || (_cache[0] = [
        _createTextVNode(" Select the typology of the worker nodes for your new pool ")
      ])),
      _: 1
    }),
    _createVNode(_component_v_row, { class: "ma-0 mx-4 mb-2" }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tagList, (tag) => {
          return (_openBlock(), _createBlock(_component_v_col, {
            class: "pa-0 mr-2 fit-content",
            key: 'tag-'+tag
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Badge, {
                label: tag,
                severity: _ctx.$enums.Severity.NEUTRAL,
                outlined: !_ctx.selectedTags.includes(tag),
                onClick: ($event: any) => (_ctx.onClickTag(tag)),
                class: "tag"
              }, null, 8, ["label", "severity", "outlined", "onClick"])
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, { class: "ma-0 mx-4 mb-2" }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nodeTypologies, (typology, index) => {
          return (_openBlock(), _createBlock(_component_v_col, {
            class: "pa-0",
            key: 'typo-' + index,
            cols: "6"
          }, {
            default: _withCtx(() => [
              (!_ctx.isTypoAbsent(typology))
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["card-typo", (index%2 === 0 ? ' mr-2 ' : ' ml-2 ') + (_ctx.selectedTypology?.id === typology.id ? ' selected ' : '') + (_ctx.isTypoDisabled(typology) ? ' disabled ' : '')]),
                    onClick: ($event: any) => (_ctx.onClickTypoCard(typology))
                  }, [
                    _createVNode(_component_v_row, { class: "ma-0 mb-2" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { class: "pa-0 fit-content" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(typology.attributes.name), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_v_col, { class: "pa-0 ml-auto fit-content" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_PriceDisplay, {
                              price: _ctx.location && typology.attributes.price ? typology.attributes.price.amount : null,
                              currency: _ctx.currency,
                              hidePeriodicity: true
                            }, null, 8, ["price", "currency"])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_v_row, { class: "ma-0 token-text-color-secondary" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(typology.attributes.cores) + " " + _toDisplayString(typology.attributes.dedicated_cpu ? ' dedicated ' : ' shared ') + " CPUs ", 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_v_row, { class: "ma-0 token-text-color-secondary" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(typology.attributes.memory) + " RAM ", 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_v_row, { class: "ma-0 token-text-color-secondary" }, {
                      default: _withCtx(() => [
                        (typology.attributes.cpu_family)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(_toDisplayString(typology.attributes.cpu_family), 1)
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode("   ")
                            ], 64))
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_v_row, { class: "ma-0 mt-1" }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(typology.attributes.tags, (tag) => {
                          return (_openBlock(), _createBlock(_component_v_col, {
                            class: "pa-0 mr-2 fit-content",
                            key: typology?.id+'-tag-'+tag
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_Badge, {
                                label: tag,
                                severity: _ctx.$enums.Severity.NEUTRAL,
                                outlined: !_ctx.selectedTags.includes(tag),
                                onClick: ($event: any) => (_ctx.onClickTag(tag)),
                                class: "tag"
                              }, null, 8, ["label", "severity", "outlined", "onClick"])
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 2
                    }, 1024)
                  ], 10, _hoisted_1))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    })
  ], 64))
}